import lazyLoading from "./lazyLoading";

export default {
  name: "evidencija",
  path: "/evidencija",
  component: lazyLoading("evidencija/Evidencija"),
  meta: {
    default: false,
    title: "Evidencija",
    class: "primary",
    show: false,
    iconClass: "fa fa-file-pdf-o",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/evidencija.js